import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * A custom element that displays the package content (Inhalt) line for the
 * selected variant. Listens for variant update events (the same event the
 * native product-price component uses) and re-renders itself from the
 * updated section HTML so it never goes stale after a variant switch.
 */
class ProductContentInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateContentInfo);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateContentInfo);
  }

  updateContentInfo = (event) => {
    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newContentInfo = event.detail.data.html.querySelector(
      `product-content-info[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newContentInfo) return;

    this.replaceWith(newContentInfo);
  };
}

if (!customElements.get('product-content-info')) {
  customElements.define('product-content-info', ProductContentInfo);
}
